import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import am from './locales/am.json'
import ru from './locales/ru.json'
import en from './locales/en.json'

function detectInitialLanguage(): 'am' | 'ru' | 'en' {
  const tgCode = window.Telegram?.WebApp?.initData
    ? new URLSearchParams(window.Telegram.WebApp.initData).get('user')
    : null
  if (tgCode) {
    try {
      const parsed = JSON.parse(tgCode) as { language_code?: string }
      const code = (parsed.language_code ?? '').toLowerCase()
      if (code === 'hy' || code === 'am') return 'am'
      if (code === 'ru') return 'ru'
      if (code) return 'en'
    } catch {
      // fall through
    }
  }
  const browser = (navigator.language || 'en').toLowerCase().split('-')[0]
  if (browser === 'hy') return 'am'
  if (browser === 'ru') return 'ru'
  return 'en'
}

void i18n.use(initReactI18next).init({
  resources: {
    am: { translation: am },
    ru: { translation: ru },
    en: { translation: en },
  },
  lng: detectInitialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
